import { cn } from '@/utils/utils';
import { Component, ErrorInfo, ReactNode } from 'react';

interface ErrorBoundaryProps {
    children: ReactNode,
    className?: string,
    content?: ReactNode
}

interface ErrorBoundaryState {
    hasError: boolean
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(_: Error): ErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('Caught an error:', error, errorInfo);
    }

    render() {
        const { className, content } = this.props;
        if (this.state.hasError) {
            return (
                <div
                    className={cn(
                        'text-center flex items-center justify-center text-[#00000099] bg-[#DDDDDD] h-full w-full',
                        className
                    )}
                >
                    {content || (
                        <>
                            エラーが発生しました。
                            <br />
                            しばらくしてからもう一度お試しください。
                        </>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
